import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneUtils } from '../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { KieneTableService } from '../kiene-table/kiene-table.service';
import { Einheit } from './einheit';

@Component({
    selector: 'kiene-einheit-selector',
    templateUrl: './einheit-selector.component.html',
    styleUrls: ['./einheit-selector.component.scss'],
})
export class EinheitSelectorComponent implements OnInit {
    einheiten: Einheit[] = [];
    einheitCtrl = new UntypedFormControl();

    @Input('preselected') preselected: Einheit;
    @Input() info: string;

    @Output('changed') changed = new EventEmitter<Einheit>();

    constructor(
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.loadEinheiten();
        if (this.preselected) {
            this.einheitCtrl.setValue(this.preselected);
        }
    }

    loadEinheiten() {
        this.api.get(this.apiBaseUrl + 'einheit/read.php').subscribe(response => {
            this.einheiten = response.records;
            this.applyPreselectedEinheit();
        });
    }

    private applyPreselectedEinheit(): void {
        const einheitId = this.preselected?.einheit_id;
        if (einheitId == null || !this.einheiten?.length) {
            return;
        }
        const match = this.einheiten.find(e => KieneUtils.sameId(e.einheit_id, einheitId));
        if (match) {
            this.einheitCtrl.setValue(match);
        }
    }

    einheitComparator(one: Einheit, two: Einheit): boolean {
        return KieneUtils.sameId(one?.einheit_id, two?.einheit_id);
    }

    einheitChanged(event: MatSelectChange) {
        this.changed.emit(event.value);
    }
}
